import { render, staticRenderFns } from "./th-ordering-button.vue?vue&type=template&id=d3edcb38&scoped=true"
import script from "./th-ordering-button.vue?vue&type=script&lang=js"
export * from "./th-ordering-button.vue?vue&type=script&lang=js"
import style0 from "./th-ordering-button.vue?vue&type=style&index=0&id=d3edcb38&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3edcb38",
  null
  
)

export default component.exports